import { useEffect, useState } from 'react'

const scrollElementItems: { element: HTMLElement | HTMLHtmlElement; default: string }[] = []

if (typeof window !== 'undefined') {
  scrollElementItems.push({
    element: window.document.body,
    default: window.document.body.style.overflow || 'auto'
  })

  scrollElementItems.push({
    element: window.document.getElementsByTagName('html')[0],
    default: window.document.getElementsByTagName('html')[0].style.overflow || 'auto'
  })
}

const useTogglePageScroll = () => {
  const [isPageScrollDisabled, setIsPageScrollDisabled] = useState(false)

  useEffect(() => {
    scrollElementItems.forEach((item) => {
      item.element.style.overflow = isPageScrollDisabled ? 'hidden' : item.default
    })
  }, [isPageScrollDisabled])

  return {
    isPageScrollDisabled,
    setIsPageScrollDisabled
  }
}

export default useTogglePageScroll
